import RestApi from './../../api/rest-api-client'
const srvcEndpoint = '/uploads'

const UploadService = {
  upload: async (data, opts) => RestApi.request('POST', srvcEndpoint, data, opts),
}

export default UploadService
